module.exports = __webpack_public_path__ + "media/assets/images/helponline-logo-964a5b3cd07304ebd305f05f98683337.svg";